module.exports = __webpack_public_path__ + "static/media/close.2dba1888.svg";